'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Info = function Info(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 445 445' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M204 269h38v38h-38zM203 136h38v114h-38z' }),
      _react2.default.createElement('path', { d: 'M222 22.5c-109.7 0-199 89.3-199 199s89.3 199 199 199 199-89.3 199-199-89.3-199-199-199zm0 379c-99.3 0-180-80.8-180-180s80.8-180 180-180 180 80.8 180 180-80.7 180-180 180z'
      })
    )
  );
};
/*eslint-enable */

exports.default = Info;
//# sourceMappingURL=Info.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Info.js